import { call } from '@apparel/core/utils/functions';
import { debounce } from 'lodash';

function _pageEvent(event: string, callback: (event: any) => any) {
    const callback$ = debounce(callback, 100);
    document.addEventListener(event, callback$);
    return () => {
        document.removeEventListener(event, callback$);
    };
}

export const onPageVisibility = (callback: (hidden: boolean, event: Event) => any) => {
    let unsubscribe: any;

    if ('hidden' in document) {
        unsubscribe = _pageEvent('visibilitychange', (e) => callback((document as any)['hidden'], e));
    } else if ('mozHidden' in document) {
        unsubscribe = _pageEvent('mozvisibilitychange', (e) => callback((document as any)['mozHidden'], e));
    } else if ('webkitHidden' in document) {
        unsubscribe = _pageEvent('webkitvisibilitychange', (e) => callback((document as any)['webkitHidden'], e));
    } else if ('msHidden' in document) {
        unsubscribe = _pageEvent('msvisibilitychange', (e) => callback((document as any)['msHidden'], e));
    } else if ('onfocusin' in document) {
        (document as any).onfocusin = callback;
        (document as any).onfocusout = callback;

        unsubscribe = () => {
            (document as any).onfocusin = null;
            (document as any).onfocusout = null;
        };
    }

    window.onpageshow = debounce((e) => callback(false, e), 100);
    window.onfocus = debounce((e) => callback(false, e), 100);
    window.onpagehide = debounce((e) => callback(true, e), 100);
    window.onblur = debounce((e) => callback(true, e), 100);

    return () => {
        call(unsubscribe);

        window.onpageshow = null;
        window.onpagehide = null;
        window.onfocus = null;
        window.onblur = null;
    };
};
